<template>
  <div class="password_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goLogin"></i>
      <div>{{ $t('login.name22') }}</div>
    </div>
    <div class="text1">{{ $t('account.name43') }}</div>
    <div class="text2">{{ $t('account.name44') }}</div>
     <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
    <el-tab-pane :label="$t('account.name45')" name="first">
        <div class="forget-password">
        <el-form ref="passWordFormRef" :model="passWordForm" :rules="passWordFormRules" label-width="0px" class="login_form">
          <el-form-item prop="phoneNo">
            <el-input v-model="passWordForm.phoneNo" :placeholder="$t('retrievePassword.name11')"  @input="handleInput"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="verCode" style="width:100%;">
              <el-input v-model="passWordForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"  @input="handleInput"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getCode(1)">{{ sendmsg }}</el-button>
          </div>
          <el-form-item prop="loginPwd">
            <el-input v-model="passWordForm.loginPwd" :placeholder="$t('retrievePassword.name6')" show-password></el-input>
          </el-form-item>

          <el-form-item prop="againPwd">
            <el-input v-model="passWordForm.againPwd" :placeholder="$t('retrievePassword.name7')" show-password></el-input>
          </el-form-item>
        </el-form>

        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="sumbit(1)">{{ $t('account.name8') }}</el-button>

        <div class="btns text-style" @click="goLogin">{{ $t('account.name39') }}</div>
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('account.name46')" name="second">
       <div class="forget-password">
        <el-form ref="passWordFormRef1" :model="passWordForm" :rules="passWordFormRules1" label-width="0px" class="login_form">
          <el-form-item prop="email">
            <el-input v-model="passWordForm.email" :placeholder="$t('retrievePassword.name3')"  @input="handleInput"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="verCode" style="width:100%;">
              <el-input v-model="passWordForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"  @input="handleInput"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getCode(2)">{{ sendmsg }}</el-button>
          </div>
          <el-form-item prop="loginPwd">
            <el-input v-model="passWordForm.loginPwd" :placeholder="$t('retrievePassword.name6')" show-password></el-input>
          </el-form-item>

          <el-form-item prop="againPwd">
            <el-input v-model="passWordForm.againPwd" :placeholder="$t('retrievePassword.name7')" show-password></el-input>
          </el-form-item>
        </el-form>

        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="sumbit(2)">{{ $t('account.name8') }}</el-button>

        <div class="btns text-style" @click="goLogin">{{ $t('account.name39') }}</div>
      </div>
    </el-tab-pane>
  </el-tabs>
  </div>
</template>
<script>
import { validatePhone, validatePass, validateEmail } from '@/utils/utils.js'
import { phoneForgetEditPwd, forgetEditPwd, forgetSendPhoneCode, forgetSendEmailCode } from '@/api/h5.js'
export default {
  data() {
    var validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('retrievePassword.name14')))
      } else if (value !== this.passWordForm.loginPwd) {
        callback(new Error(this.$t('retrievePassword.name15')))
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      // 这是登录表单的数据对象
      passWordForm: {
        email: '',
        phoneNo: '',
        verCode: '',
        loginPwd: '',
        againPwd: ''
      },
      // 这是表单验证规则对象
      passWordFormRules: {
        // 验证用户名是否合法

        phoneNo: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        verCode: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
          // {
          //   min: 6,
          //   max: 15,
          //   message: '长度在 6 到 15 个字符',
          //   trigger: 'blur'
          // }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      passWordFormRules1: {
        // 验证用户名是否合法

        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        // 验证密码是否合法
        verCode: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
          // {
          //   min: 6,
          //   max: 15,
          //   message: '长度在 6 到 15 个字符',
          //   trigger: 'blur'
          // }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      code: '',
      codeLoading: false,
      readonlyInput: true,
      isSend: true,
      sendmsg: this.$t('retrievePassword.name12')
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {},
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false
    },
    handleClick() {
      this.passWordForm = {
        email: '',
        phoneNo: '',
        verCode: '',
        loginPwd: '',
        againPwd: ''
      }
    },
    handleInput() {
      this.passWordForm.phoneNo = this.passWordForm.phoneNo.replace(/\D/g, '')
      this.passWordForm.verCode = this.passWordForm.verCode.replace(/\D/g, '')
    },
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.isShowYS = !this.isShowYS
    },
    getCode(type) {
      if (type === 1) {
        if (this.passWordForm.phoneNo && this.passWordForm.phoneNo.length === 11) {
          this.codeLoading = true
          const params = {
            phoneNo: 'CN-86-' + this.passWordForm.phoneNo
          }
          forgetSendPhoneCode(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: this.$t('public.name17'),
                  type: 'success'
                })
                this.isSend = false
                let timer = 60
                this.sendmsg = timer + 's'
                this.timeFun = setInterval(() => {
                  --timer
                  this.sendmsg = timer + 's'
                  if (timer === 0) {
                    this.isSend = true
                    this.sendmsg = this.$t('retrievePassword.name13')
                    clearInterval(this.timeFun)
                  }
                }, 1000)
              }
              this.codeLoading = false
            })
            .catch(() => {
              this.codeLoading = false
            })
        }
      } else {
        this.codeLoading = true
        const params = {
          email: this.passWordForm.email
        }
        forgetSendEmailCode(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('public.name17'),
                type: 'success'
              })
              this.isSend = false
              let timer = 60
              this.sendmsg = timer + 's'
              this.timeFun = setInterval(() => {
                --timer
                this.sendmsg = timer + 's'
                if (timer === 0) {
                  this.isSend = true
                  this.sendmsg = this.$t('retrievePassword.name13')
                  clearInterval(this.timeFun)
                }
              }, 1000)
            }
            this.codeLoading = false
          })
          .catch(() => {
            this.codeLoading = false
          })
      }
    },
    goLogin() {
      this.$router.replace('/login')
    },
    sumbit(type) {
      if (type === 1) {
        this.$refs.passWordFormRef.validate((valid) => {
          if (valid) {
            this.loading = true
            const passWordForm = {
              phoneNo: 'CN-86-' + this.passWordForm.phoneNo,
              verCode: this.passWordForm.verCode,
              loginPwd: this.passWordForm.loginPwd
            }
            phoneForgetEditPwd(passWordForm)
              .then((res) => {
                if (res.code === 200) {
                  this.$router.replace('/login')
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      } else {
        this.$refs.passWordFormRef1.validate((valid) => {
          if (valid) {
            this.loading = true
            const passWordForm = {
              email: this.passWordForm.email,
              verCode: this.passWordForm.verCode,
              loginPwd: this.passWordForm.loginPwd
            }
            forgetEditPwd(passWordForm)
              .then((res) => {
                if (res.code === 200) {
                  this.$router.replace('/login')
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.forget-password{
  .el-input__inner{
    height: 49px;
  line-height: 49px;
  border: 0px solid #DCDFE6;
  background: #fff;
  }
}
.tabs{
  .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
}
.el-tabs__nav-wrap::after{
 position: static !important;
}
}
</style>

<style lang="scss" scoped>
.password_container {
  // background: #F6F7FB;
  background: linear-gradient( 180deg, #E8F1FB 0%, #FFFFFF 100%);
  // background-size: cover;
  width: 100%;
  height: 100vh;
  // overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .img {
    width: 100%;
    height: 24.65vw;
    // min-width: 1440px;
    min-height: 355px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
.code-layout {
  display: flex;
  overflow: hidden;
  // align-items: center;
  // height: 37px;
  justify-content: space-between;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
}
.ystk {
  color: #0f73e6;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
}
.code-input {
  // width:calc(100vw - 160px);
}
.code {
  height: 49px;
  font-size: 14px;
  margin-top: 1px;
  text-align: center;
  // width: 120px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
}

.fhzsb {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    color: #b9babb;
    margin-left: 4px;
  }
}
.text1{
  font-size: 20px;
  margin-left: 15px;
  font-weight: 600;
  color: #555555;
  margin-top: 30px;
}
.text2{
  font-size: 12px;
  color: #555555;
  margin-left: 15px;
  margin-top: 10px;
}

.top-layout {
  display: flex;
  align-items: center;
  position: relative;
  height: 54px;
  .el-icon-arrow-left {
   font-size: 18px;
   font-weight: 600;
   margin-left: 15px;
   cursor: pointer;
  }
  div {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    font-weight: 800;
    line-height: 28px;
    text-align: left;
    color: #171717;
  }
}

.forget-password {
  width: 100%;
  padding-top: 0px;
  padding: 30px 15px 15px 15px;
  border-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #555555;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}
}
</style>
